import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_SubstanceAbuseAdmission = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_SubstanceAbuseAdmission' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>STATE OF FLORIDA</h3></p>

                <p className='w-750'><h3>SUBSTANCE ABUSE & MENTAL HEALTH</h3></p>

                <p className='w-750'><h3>SUBSTANCE ABUSE ADMISSION FORM</h3></p>

                <p className='w-750'>
                    <b>Page 6A- 3</b>
                </p>



                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. *CONTRACTOR IDENTIFIER:</span><span className='small'>593128476</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. *SITE IDENTIFIER:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>5. *RESIDENT COUNTY:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtConractor' name='txtConractor' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSiteIdentifier' name='txtSiteIdentifier' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClientSsn' name='txtClientSsn' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6. *HIGHEST EDUCATION:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu' id='chkHighestEdu' className='add-only' value='1' />00 - No Schooling
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu2' id='chkHighestEdu2' className='add-only' value='1' />01 - Grade 1
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu3' id='chkHighestEdu3' className='add-only' value='1' />30 - Associate's Degree (AA, AS, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu4' id='chkHighestEdu4' className='add-only' value='1' />02 - Grade 2
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu5' id='chkHighestEdu5' className='add-only' value='1' />03 - Grade 3
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu6' id='chkHighestEdu6' className='add-only' value='1' />31 - Bachelor's Degree (BA, BS, AB, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu7' id='chkHighestEdu7' className='add-only' value='1' />04 - Grade 4
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu8' id='chkHighestEdu8' className='add-only' value='1' />05 - Grade 5
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu9' id='chkHighestEdu9' className='add-only' value='1' />32 - Master's Degree (MS, MA, MSW, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu10' id='chkHighestEdu10' className='add-only' value='1' />06 - Grade 6
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu11' id='chkHighestEdu11' className='add-only' value='1' />07 - Grade 7
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu12' id='chkHighestEdu12' className='add-only' value='1' />33 - Professional Degree (MD, DDS, JD, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu13' id='chkHighestEdu13' className='add-only' value='1' />08 - Grade 8
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu14' id='chkHighestEdu14' className='add-only' value='1' />24 - Grade 9
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu15' id='chkHighestEdu15' className='add-only' value='1' />34 - Doctorate Degree (PhD, EDD, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu16' id='chkHighestEdu16' className='add-only' value='1' />25 - Grade 10
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu17' id='chkHighestEdu17' className='add-only' value='1' />26 - Grade 11
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu18' id='chkHighestEdu18' className='add-only' value='1' />35 - Special School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu19' id='chkHighestEdu19' className='add-only' value='1' />27 - Grade 12
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu20' id='chkHighestEdu20' className='add-only' value='1' />36 - Vocational School
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu21' id='chkHighestEdu21' className='add-only' value='1' />28 - High School Graduate, Diploma/GED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkHighestEdu23' id='chkHighestEdu23' className='add-only' value='1' />38 - College Undergraduate Freshman (2nd Year)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu22' id='chkHighestEdu22' className='add-only' value='1' />37 - College Undergraduate Freshman (1st Year)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkHighestEdu24' id='chkHighestEdu24' className='add-only' value='1' />39 - College Undergraduate Freshman (3rd Year)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu25' id='chkHighestEdu25' className='add-only' value='1' />40 - College Undergraduate Freshman (4th Year)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu26' id='chkHighestEdu26' className='add-only' value='1' />41 - Kindergarten
                        </td>
                        <td className='w-550'>
                            <input type='checkbox' name='chkHighestEdu27' id='chkHighestEdu27' className='add-only' value='1' />42 - Nursery School/Preschool/Head Start
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. *MARITAL STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus' id='chkMerritalStatus' className='add-only' value='1' />1 - Single
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus1' id='chkMerritalStatus1' className='add-only' value='1' />2 - Married
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkMerritalStatus2' id='chkMerritalStatus2' className='add-only' value='1' />5 - Separated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus3' id='chkMerritalStatus3' className='add-only' value='1' />6 - Unreported
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus4' id='chkMerritalStatus4' className='add-only' value='1' />3 - Widowed
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkMerritalStatus5' id='chkMerritalStatus5' className='add-only' value='1' />7 - Registered Domestic Partner
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus6' id='chkMerritalStatus6' className='add-only' value='1' />4 - Divorced
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus7' id='chkMerritalStatus7' className='add-only' value='1' />8 - Legally Separated
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8. *HEALTH STATUS (HIPAA):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus' id='chkHealthStatus' className='add-only' value='1' />1 - Agitated
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus1' id='chkHealthStatus1' className='add-only' value='1' />4 - Depressed
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHealthStatus2' id='chkHealthStatus2' className='add-only' value='1' />7 - Other Mental Condition
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus3' id='chkHealthStatus3' className='add-only' value='1' />2 - Comatose
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus4' id='chkHealthStatus4' className='add-only' value='1' />5 - Forgetful
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHealthStatus5' id='chkHealthStatus5' className='add-only' value='1' />8 - Oriented
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus6' id='chkHealthStatus6' className='add-only' value='1' />3 - Disoriented
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus7' id='chkHealthStatus7' className='add-only' value='1' />6 - Lethargic
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. *PREGNANCY TRIMESTER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus' id='chkPregnancyStatus' className='add-only' value='1' />1 - 1-3 Months
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus1' id='chkPregnancyStatus1' className='add-only' value='1' />3 - 7-9 Months
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkPregnancyStatus2' id='chkPregnancyStatus2' className='add-only' value='1' />5 - Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus3' id='chkPregnancyStatus3' className='add-only' value='1' />2 - 4-6 Months
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus4' id='chkPregnancyStatus4' className='add-only' value='1' />4 - Not Pregnant or male
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A- 4</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. *ADMISSION TYPE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkAdmissionStatus' id='chkAdmissionStatus' className='add-only' value='1' />1 - Voluntary Competent
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkAdmissionStatus1' id='chkAdmissionStatus1' className='add-only' value='1' />3 - Involuntary Competent
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdmissionStatus2' id='chkAdmissionStatus2' className='add-only' value='1' />2 - Voluntary Incompetent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdmissionStatus3' id='chkAdmissionStatus3' className='add-only' value='1' />4 - Involuntary Incompetent
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>11. *DRUG COURT ORDERED:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish_Yes' name='rbEnglish' className='add-only' value='1' /> 0-No
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish_No' name='rbEnglish' className='add-only' value='2' /> 1-Yes
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>12. *INVOLVED IN CHILD WELFARE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish1_Yes' name='rbEnglish1' className='add-only' value='1' /> 0-No
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish1_No' name='rbEnglish1' className='add-only' value='2' /> 1-Yes
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>13. *RESIDENTIAL STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus' id='chkResidentalStatus' className='add-only' value='1' />01 - Independent Living-alone
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus1' id='chkResidentalStatus1' className='add-only' value='1' />10 - State MH Treatment Facility (State Hospital)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus2' id='chkResidentalStatus2' className='add-only' value='1' />02 - Independent Living-with Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus3' id='chkResidentalStatus3' className='add-only' value='1' />11 - Nursing Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus4' id='chkResidentalStatus4' className='add-only' value='1' />03 - Independent Living-with Non-Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus5' id='chkResidentalStatus5' className='add-only' value='1' />12 - Supported Housing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus6' id='chkResidentalStatus6' className='add-only' value='1' />04 - Dependent Living-with Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus7' id='chkResidentalStatus7' className='add-only' value='1' />13 - Correctional Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus8' id='chkResidentalStatus8' className='add-only' value='1' />05 - Dependent Living-with Non-Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus9' id='chkResidentalStatus9' className='add-only' value='1' />14 - DJJ Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus10' id='chkResidentalStatus10' className='add-only' value='1' />06 - Assisted Living Facility (ALF)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus11' id='chkResidentalStatus11' className='add-only' value='1' />15 - Crisis Residence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus12' id='chkResidentalStatus12' className='add-only' value='1' />07 - Foster Care/Home
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus13' id='chkResidentalStatus13' className='add-only' value='1' />16 - Children Residential Treatment Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus14' id='chkResidentalStatus14' className='add-only' value='1' />08 - Adult Residential Treatment Facility (Group Home)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus15' id='chkResidentalStatus15' className='add-only' value='1' />17 - Limited Mental Health Licensed ALF
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus16' id='chkResidentalStatus16' className='add-only' value='1' />09 - Homeless
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus17' id='chkResidentalStatus17' className='add-only' value='1' />18 - Other Residential Status
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus18' id='chkResidentalStatus18' className='add-only' value='1' />99 - Not Available or Unknown
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>14. *DEPENDENCY/CRIMINAL STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated' id='chkAdjudicated' className='add-only' value='1' />00 - Insufficient Information
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Adjudicated Children:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated31' id='chkAdjudicated31' className='add-only' value='1' />01 - Delinquent, in physical custody
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated30' id='chkAdjudicated30' className='add-only' value='1' />02 - Delinquent, not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated29' id='chkAdjudicated29' className='add-only' value='1' />03 - Dependent, in physical custody
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated28' id='chkAdjudicated28' className='add-only' value='1' />04 - Dependent, not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated27' id='chkAdjudicated27' className='add-only' value='1' />05 - Dependent & Delinquent, in physical custody
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated26' id='chkAdjudicated26' className='add-only' value='1' />06 - Dependent & Delinquent, not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated25' id='chkAdjudicated25' className='add-only' value='1' />07 - 'Children in Need of services' (CINS), not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Non-Adjudicated Children</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated24' id='chkAdjudicated24' className='add-only' value='1' />08 - Other DCF program status
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated23' id='chkAdjudicated23' className='add-only' value='1' />09 - Under custody & supervision of family/guardian
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Adults with No Court Jurisdiction:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated21' id='chkAdjudicated21' className='add-only' value='1' />10 - Competent, no charges
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated20' id='chkAdjudicated20' className='add-only' value='1' />11 - Civil incompetence of person or property
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Adults with Court Jurisdiction:<br />
                                Criminal Competent</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated19' id='chkAdjudicated19' className='add-only' value='1' />12 - Incarcerated
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated18' id='chkAdjudicated18' className='add-only' value='1' />13 - Release pending hearing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated17' id='chkAdjudicated17' className='add-only' value='1' />14 - this code is no longer used
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated16' id='chkAdjudicated16' className='add-only' value='1' />15 - this code is no longer used
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated15' id='chkAdjudicated15' className='add-only' value='1' />16 - Release pending hearing ITP
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated14' id='chkAdjudicated14' className='add-only' value='1' />17 - Involuntarily hospitalized (direct commit)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated11' id='chkAdjudicated11' className='add-only' value='1' />20 - No longer used
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated10' id='chkAdjudicated10' className='add-only' value='1' />21 - Conditionally released
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated13' id='chkAdjudicated13' className='add-only' value='1' />18 - Incarcerated
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated12' id='chkAdjudicated12' className='add-only' value='1' />19 - Involuntarily hospitalized - revocation of conditional
                            release.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Not Guilty by Reason of Insanity (NGI):</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated7' id='chkAdjudicated7' className='add-only' value='1' />24 - Released pending hearing.
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated6' id='chkAdjudicated6' className='add-only' value='1' />25 - Conditionally released.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated5' id='chkAdjudicated5' className='add-only' value='1' />26 - Incarcerated.
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated4' id='chkAdjudicated4' className='add-only' value='1' />29 - Incompetent to proceed - Ages 21+
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated9' id='chkAdjudicated9' className='add-only' value='1' />22 - Involuntary hospital - direct commit.
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated8' id='chkAdjudicated8' className='add-only' value='1' />23 - Involuntary hospital - revocation of conditional
                            release.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Juvenile Incompetent to Proceed</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated3' id='chkAdjudicated3' className='add-only' value='1' />27 - Incompetent to Proceed - Ages 0 - 17
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated2' id='chkAdjudicated2' className='add-only' value='1' />28 - Incompetent to Proceed - Ages 18 - 20
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated1' id='chkAdjudicated1' className='add-only' value='1' />28 - Incompetent to Proceed - Age 21
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Pages 6A - 4 and 5</b>
                </p>
                <p className='w-750'>
                    <b>Drug list in Appendix 5</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*SUBSTANCE PROBLEM</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>15. *Primary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>16. Secondary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>17. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary' name='txtPrimary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary' name='txtSecondary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary' name='txtTertiary' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 5</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*USUAL ROUTE OF ADMINISTRATION</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>18. *Primary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_Yes' name='rbUsualRoute' className='add-only' value='1' /> 1 - Oral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_Ys' name='rbUsualRoute' className='add-only' value='2' /> 4 - Injection
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_No' name='rbUsualRoute' className='add-only' value='3' /> 2 - Smoking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_Nu' name='rbUsualRoute' className='add-only' value='4' /> 3 - Inhalation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsualRoute_Ni' name='rbUsualRoute' className='add-only' value='5' /> 5 - Other &nbsp;
                            <input type='text' id='txtUsualRoute' name='txtUsualRoute' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>19. Secondary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_Yes' name='rbUsualRoute1' className='add-only' value='1' /> 1 - Oral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_Ys' name='rbUsualRoute1' className='add-only' value='2' /> 4 - Injection
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_No' name='rbUsualRoute1' className='add-only' value='3' /> 2 - Smoking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_Nu' name='rbUsualRoute1' className='add-only' value='4' /> 3 - Inhalation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsualRoute1_Ni' name='rbUsualRoute1' className='add-only' value='5' /> 5 - Other &nbsp;
                            <input type='text' id='txtUsualRoute1' name='txtUsualRoute1' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>20. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_Yes' name='rbUsualRoute2' className='add-only' value='1' /> 1 - Oral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_Ys' name='rbUsualRoute2' className='add-only' value='2' /> 4 - Injection
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_No' name='rbUsualRoute2' className='add-only' value='3' /> 2 - Smoking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_Nu' name='rbUsualRoute2' className='add-only' value='4' /> 3 - Inhalation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsualRoute2_Ni' name='rbUsualRoute2' className='add-only' value='5' /> 5 - Other &nbsp;
                            <input type='text' id='txtUsualRoute2' name='txtUsualRoute2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 5 and 6 </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*FREQUENCY OF USE (MONTH PRIOR TO EVALUATION)</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>21. *Primary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Yes' name='rbUsualRoutePr' className='add-only' value='1' /> 1 - No past month use
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Ys' name='rbUsualRoutePr' className='add-only' value='2' /> 4 - 3 to 6 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_No' name='rbUsualRoutePr' className='add-only' value='3' /> 2 - 1 to 3 times in past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Nu' name='rbUsualRoutePr' className='add-only' value='4' /> 3 - 1 to 2 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Ni' name='rbUsualRoutePr' className='add-only' value='5' /> 5 - Daily &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>22. Secondary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Yes' name='rbUsualRoutePr1' className='add-only' value='1' /> 1 - No past month use
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Ys' name='rbUsualRoutePr1' className='add-only' value='2' /> 4 - 3 to 6 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_No' name='rbUsualRoutePr1' className='add-only' value='3' /> 2 - 1 to 3 times in past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Nu' name='rbUsualRoutePr1' className='add-only' value='4' /> 3 - 1 to 2 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Ni' name='rbUsualRoutePr1' className='add-only' value='5' /> 5 - Daily &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>23. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Yes' name='rbUsualRoutePr2' className='add-only' value='1' /> 1 - No past month use
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Ys' name='rbUsualRoutePr2' className='add-only' value='2' /> 4 - 3 to 6 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_No' name='rbUsualRoutePr2' className='add-only' value='3' /> 2 - 1 to 3 times in past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Nu' name='rbUsualRoutePr2' className='add-only' value='4' /> 3 - 1 to 2 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Ni' name='rbUsualRoutePr2' className='add-only' value='5' /> 5 - Daily &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 6 </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*AGE OF FIRST DRUG OR ALCOHOL USE</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>24. *Primary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>25. Secondary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>26. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary24' name='txtPrimary24' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary25' name='txtSecondary25' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary26' name='txtTertiary26' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><b>27. *STAFF ID:</b>&nbsp;
                    <input type='text' id='txtStaffId' name='txtStaffId' className='add-only w-350 custom-add-only' /></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>28. *PURPOSE OF EVALUATION:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>29. EVALUATION DATE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='chkPurpose' id='chkPurpose' className='add-only' value='1' />1 - Initial &nbsp; &nbsp;
                            <input type='checkbox' name='chkPurpose1' id='chkPurpose1' className='add-only' value='1' />2 - Immediate Discharge
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtEvalDate' name='txtEvalDate' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>Page 6A - 7</b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>30. *CHILD PREVENTION:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>31. *DRUGS HARMFUL:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>32. *ALCOHOL HARMFUL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish30_Yes' name='rbEnglish30' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish30_No' name='rbEnglish30' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish31_Yes' name='rbEnglish31' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish31_No' name='rbEnglish31' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish32_Yes' name='rbEnglish32' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish32_No' name='rbEnglish32' className='add-only' value='2' /> 1 - Yes
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>33. *TOBACCO HARMFUL:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>34. *TOBACCO USE:</span>
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish33_Yes' name='rbEnglish33' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish33_No' name='rbEnglish33' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish34_Yes' name='rbEnglish34' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish34_No' name='rbEnglish34' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>35. *LEGAL GUARDIAN:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkLegalGuar' id='chkLegalGuar' className='add-only' value='1' />1 - Parent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkLegalGuar1' id='chkLegalGuar1' className='add-only' value='1' />3 - Non-Relative
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkLegalGuar2' id='chkLegalGuar2' className='add-only' value='1' />5 - State or Public Agency
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkLegalGuar3' id='chkLegalGuar3' className='add-only' value='1' />2 - Other Relative
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkLegalGuar4' id='chkLegalGuar4' className='add-only' value='1' />4 - Emancipated Minor
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkLegalGuar5' id='chkLegalGuar5' className='add-only' value='1' />6 - Not Applicable
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>36. *EMPLOYMENT:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment' id='chkEmployment' className='add-only' value='1' />10 - Active Military, Overseas
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment1' id='chkEmployment1' className='add-only' value='1' />70 - Terminated/Unemployed
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment2' id='chkEmployment2' className='add-only' value='1' />11 - Active Military, USA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkEmployment3' id='chkEmployment3' className='add-only' value='1' />81 - Homemaker (must keep house for 1 or more others)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment4' id='chkEmployment4' className='add-only' value='1' />12 - Full Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment5' id='chkEmployment5' className='add-only' value='1' />82 - Student
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment6' id='chkEmployment6' className='add-only' value='1' />31 - *Unpaid Family Worker
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment7' id='chkEmployment7' className='add-only' value='1' />83 - Disabled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment8' id='chkEmployment8' className='add-only' value='1' />40 - Part Time
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment9' id='chkEmployment9' className='add-only' value='1' />84 - Criminal Inmate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment11' id='chkEmployment11' className='add-only' value='1' />50 - Leave of Absence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment12' id='chkEmployment12' className='add-only' value='1' />85 - Inmate Other
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment13' id='chkEmployment13' className='add-only' value='1' />60 - Retired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment14' id='chkEmployment14' className='add-only' value='1' />86 - Not Authorized to Work
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    *Note: Unpaid Family Worker - A family member who works at least 15 hours or more a week without pay in a family-
                    operated enterprise. If an individual refuses to work because they are making money through illegal activities (i.e., drug
                    sales or prostitution) the client should be coded as unemployed '70'.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>37. *PRIMARY INCOME SOURCE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome' id='chkPrimaryIncome' className='add-only' value='1' />1 - Salary
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome1' id='chkPrimaryIncome1' className='add-only' value='1' />4 - Disability
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome2' id='chkPrimaryIncome2' className='add-only' value='1' />7 - Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome3' id='chkPrimaryIncome3' className='add-only' value='1' />2 - TANF
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome4' id='chkPrimaryIncome4' className='add-only' value='1' />5 - Other
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome5' id='chkPrimaryIncome5' className='add-only' value='1' />3 - Retirement/Pension/SSI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPrimaryIncome6' id='chkPrimaryIncome6' className='add-only' value='1' />6 - None
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 8</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>38. *PERSONAL INCOME:</span>Enter annual income by thousands (01-98) or choose one of the following codes:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPersonalIncome' id='chkPersonalIncome' className='add-only' value='1' />1 - No Income
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPersonalIncome1' id='chkPersonalIncome1' className='add-only' value='1' />98 - Income Over 98,000
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPersonalIncome2' id='chkPersonalIncome2' className='add-only' value='1' />99 - Unknown Income
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>39. *FAMILY INCOME:</span>Enter annual family income by thousands (01-98) or choose one of the following codes:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkFamilyIncome' id='chkFamilyIncome' className='add-only' value='1' />1 - No Income
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkFamilyIncome1' id='chkFamilyIncome1' className='add-only' value='1' />98 - Income Over 98,000
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkFamilyIncome2' id='chkFamilyIncome2' className='add-only' value='1' />99 - Unknown Income
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>40. *WAITING DAYS:</span>Enter number of days client waited to be admitted into appropriate service.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkWaitingDays' id='chkWaitingDays' className='add-only' value='1' />999 = Unknown
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkWaitingDays1' id='chkWaitingDays1' className='add-only' value='1' />000 = No Days Waiting
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>41. *POST PARTUM:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPostPartum' id='chkPostPartum' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPostPartum1' id='chkPostPartum1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkPostPartum2' id='chkPostPartum2' className='add-only' value='1' />3 - Unknown (Must be space if male)
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>42. DEPENDENTS: Enter number of dependents. 1 through 9 (9 = 9 or more): </b>&nbsp;
                    <input type='text' id='txtDependents' name='txtDependents' className='add-only w-200 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>43. *DEVELOPMENT STATUS:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>44. *PHYSICAL DISABILITY:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbEnglish43_Yes' name='rbEnglish43' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish43_No' name='rbEnglish43' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbEnglish44_Yes' name='rbEnglish44' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish44_No' name='rbEnglish44' className='add-only' value='2' /> 1 - Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>45. *AMBULATORY STATUS:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>46. *VISUALLY IMPAIRED:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbEnglish45_Yes' name='rbEnglish45' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish45_No' name='rbEnglish45' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbEnglish46_Yes' name='rbEnglish46' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish46_No' name='rbEnglish46' className='add-only' value='2' /> 1 - Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 9
                    </b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>47. *HEARING IMPAIRED:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>48. *ENGLISH IMPAIRED:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbEnglish47_Yes' name='rbEnglish47' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish47_No' name='rbEnglish47' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbEnglish48_Yes' name='rbEnglish48' className='add-only' value='1' /> 0 - No &nbsp;
                            <input type='radio' id='rbEnglish48_No' name='rbEnglish48' className='add-only' value='2' /> 1 - Yes
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>49. *REFERRAL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral1' id='chkReferral1' className='add-only' value='1' />1 - Individual (Self-Referral)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral2' id='chkReferral2' className='add-only' value='1' />3 - Mental Health Care Provider
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral3' id='chkReferral3' className='add-only' value='1' />4 - Juvenile Justice (JARF's)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral4' id='chkReferral4' className='add-only' value='1' />5 - County Public Health Unit
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral5' id='chkReferral5' className='add-only' value='1' />6 - School (Education)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral6' id='chkReferral6' className='add-only' value='1' />9 - TASC (Assessment Centers)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral7' id='chkReferral7' className='add-only' value='1' />13 - Prison/Jail
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral8' id='chkReferral8' className='add-only' value='1' />11 - DUI/DWI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral9' id='chkReferral9' className='add-only' value='1' />12 - Pretrial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral10' id='chkReferral10' className='add-only' value='1' />16 - SINS/FINS
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral11' id='chkReferral11' className='add-only' value='1' />18 - Outreach Program
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral12' id='chkReferral12' className='add-only' value='1' />19 - DCF/ADM (no longer used)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral13' id='chkReferral13' className='add-only' value='1' />20 - Community Hospital
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral14' id='chkReferral14' className='add-only' value='1' />21 - State Hospital
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral15' id='chkReferral15' className='add-only' value='1' />22 - Physician/Doctor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral16' id='chkReferral16' className='add-only' value='1' />23 - Law Enforcement
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral17' id='chkReferral17' className='add-only' value='1' />24 - Family Safety Foster Care
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkReferral18' id='chkReferral18' className='add-only' value='1' />99 - None of the Above
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral19' id='chkReferral19' className='add-only' value='1' />2 - Substance Abuse Care Provider
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral20' id='chkReferral20' className='add-only' value='1' />7 - Employer/Employee Assistance Program
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral21' id='chkReferral21' className='add-only' value='1' />8 - Other Social Service/HeaIth/Community Ref
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral22' id='chkReferral22' className='add-only' value='1' />10 - Probation/ParoIe/ControlIed Release Authority
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral23' id='chkReferral23' className='add-only' value='1' />14 - Other Court Order/Recognized Legal Entity
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral24' id='chkReferral24' className='add-only' value='1' />17 - Addictions Receiving Facilities
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkReferral25' id='chkReferral25' className='add-only' value='1' />25 - Family Safety Protective Services
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>50. *CRIMINAL JUSTICE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkCriminalJustice' id='chkCriminalJustice' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkCriminalJustice1' id='chkCriminalJustice1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkCriminalJustice2' id='chkCriminalJustice2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>51. ARREST_ MUST be space filled</b><br />
                    A new Arrest field is listed below which is now a 2-digit field: &nbsp;
                    <input type='text' id='txtArrest' name='txtArrest' className='add-only w-300 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>52. IV HISTORY:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkHistory' id='chkHistory' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkHistory1' id='chkHistory1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkHistory2' id='chkHistory2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>53. PRIOR ADMISSIONS:</b><br />
                    Enter number of prior admissions into any SA treatment agency: &nbsp;
                    <input type='text' id='txtPriorAdmissions' name='txtPriorAdmissions' className='add-only w-300 custom-add-only' />
                </p>
                <p className='w-750'>
                    <b>54. PROVIDER INFORMATION:</b>: &nbsp;
                    <input type='text' id='txtProviderInformation' name='txtProviderInformation' className='add-only w-300 custom-add-only' />
                </p>
                <p className='w-750'>
                    <b>55. ZIP CODE:</b> US Postal Zip code for this client's residence: &nbsp;
                    <input type='text' id='txtZipCode' name='txtZipCode' className='add-only w-300 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>56. TANF STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTanfStatus' id='chkTanfStatus' className='add-only' value='1' />1 - Temporary Cash Assistance
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTanfStatus1' id='chkTanfStatus1' className='add-only' value='1' />2 - Diversion Family Program
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTanfStatus2' id='chkTanfStatus2' className='add-only' value='1' />3 - Not a TANF Client
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>57. FAMILY SIZE:</b> Number of persons living in household 1 through 9 (9 = 9 or more): &nbsp;
                    <input type='text' id='txtFamilySize' name='txtFamilySize' className='add-only w-150 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>58. *SUBSTANCE ABUSE PROBLEM:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish58_Yes' name='rbEnglish58' className='add-only' value='1' /> 0 - No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish58_No' name='rbEnglish58' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 10</b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>59. *PROVIDER ID:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>60. SA DIAGONSIS:</span><span className='small'>Must be space filled</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>61. MH DIAGONSIS:</span><span className='small'>Must be space filled</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary59' name='txtPrimary59' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary60' name='txtSecondary60' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary61' name='txtTertiary61' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>62. *MARCHMAN ACT:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkMarchman' id='chkMarchman' className='add-only' value='1' />1 - Involuntary Assessment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkMarchman1' id='chkMarchman1' className='add-only' value='1' />2 - Involuntary Treatment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkMarchman2' id='chkMarchman2' className='add-only' value='1' />4 - Not Applicable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkMarchman3' id='chkMarchman3' className='add-only' value='1' />3 - Involuntary Assessment and Treatment
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>63. *COLLATERAL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkCollateral' id='chkCollateral' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkCollateral1' id='chkCollateral1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkCollateral2' id='chkCollateral2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>64. *OPIOID REPLACEMENT:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkOpioid' id='chkOpioid' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkOpioid1' id='chkOpioid1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkOpioid2' id='chkOpioid2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>65. *VETERAN STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkVeteran' id='chkVeteran' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkVeteran1' id='chkVeteran1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkVeteran2' id='chkVeteran2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>66. *CONTACT NUMBER 1:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>67. CONTACT NUMBER 2:</span><span className='small'>(NO LONGER USED-MUST BE SPACE FILLED)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>68. CONTACT NUMBER 3:</span><span className='small'>(NO LONGER USED-MUST BE SPACE FILLED)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtContactNumber' name='txtContactNumber' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactNumber1' name='txtContactNumber1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactNumber2' name='txtContactNumber2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>69. *MHDIAGONSIS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish69_Yes' name='rbEnglish69' className='add-only' value='1' /> 0 - No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEnglish69_No' name='rbEnglish69' className='add-only' value='2' /> 1 - Yes
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>70. *SOCIAL CONNECTEDNESS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected2' id='chkSocialConnected2' className='add-only' value='1' />02 - 1-3 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected3' id='chkSocialConnected3' className='add-only' value='1' />03 - 4-7 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected4' id='chkSocialConnected4' className='add-only' value='1' />04 - 8-15 times in past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected5' id='chkSocialConnected5' className='add-only' value='1' />05 - 16-30 times in past month
                        </td>
                        <td className='w-500'>
                            <input type='checkbox' name='chkSocialConnected' id='chkSocialConnected' className='add-only' value='1' />01 - No attendance in the past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkSocialConnected6' id='chkSocialConnected6' className='add-only' value='1' />06 - Some attendance in past month, frequency unknown
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6A - 11
                    </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>71. *SCHOOL ATTENDANCE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence' id='chkSocialAttendence' className='add-only' value='1' />1 - Suspended
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence2' id='chkSocialAttendence2' className='add-only' value='1' />2 - Expelled
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence3' id='chkSocialAttendence3' className='add-only' value='1' />3 - Suspended and Expelled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence4' id='chkSocialAttendence44' className='add-only' value='1' />4 - Not Applicable
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>72. *ARREST:</b> Number of arrests in the last 30 days
                    <input type='text' id='txtFamilySize72' name='txtFamilySize72' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>73. *SADIAG10:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>74. MHDIAG10:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactNumber73' name='txtContactNumber73' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtContactNumber74' name='txtContactNumber74' className='add-only' />
                        </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}

